const isDevelopment = typeof process !== 'undefined' && process.env?.NODE_ENV === 'development';

const readPublicApiUrl = () =>
  (typeof process !== 'undefined' && process.env?.PUBLIC_API_URL) ||
  (typeof window !== 'undefined' && window.PUBLIC_API_URL) ||
  '';

const readHostname = () =>
  typeof window !== 'undefined' && window.location?.hostname ? window.location.hostname : '';

const isStagingOrDevDemo = () => {
  const apiUrl = readPublicApiUrl().toLowerCase();
  const hostname = readHostname().toLowerCase();

  const hostLooksAllowed =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.includes('stagingdemo') ||
    hostname.includes('devdemo') ||
    hostname.startsWith('staging') ||
    hostname.startsWith('dev');

  const apiLooksAllowed =
    apiUrl.includes('/stagingdemo/') ||
    apiUrl.includes('/devdemo/') ||
    apiUrl.includes('/staging/') ||
    apiUrl.includes('/dev/');

  return hostLooksAllowed || apiLooksAllowed;
};

const readE2EEFlagValue = () =>
  (typeof process !== 'undefined' &&
    (process.env?.PUBLIC_RESPONDER_MESSENGER_E2EE_ENABLED ||
      process.env?.REACT_APP_RESPONDER_MESSENGER_E2EE_ENABLED)) ||
  (typeof window !== 'undefined' &&
    (window.PUBLIC_RESPONDER_MESSENGER_E2EE_ENABLED ||
      window.REACT_APP_RESPONDER_MESSENGER_E2EE_ENABLED)) ||
  '';

const resolveResponderE2EEFlagDiagnostics = () => {
  const isAllowedEnvironment = isDevelopment || isStagingOrDevDemo();
  const explicit = `${readE2EEFlagValue()}`.trim().toLowerCase();
  const isExplicitTrue = explicit === 'true' || explicit === '1' || explicit === 'yes';
  const isExplicitFalse = explicit === 'false' || explicit === '0' || explicit === 'no';

  let enabled = false;
  if (!isAllowedEnvironment) {
    enabled = false;
  } else if (isExplicitTrue) {
    enabled = true;
  } else if (isExplicitFalse) {
    enabled = false;
  } else {
    enabled = true;
  }

  return {
    enabled,
    explicit,
    isDevelopment,
    isAllowedEnvironment,
    apiUrl: readPublicApiUrl(),
    hostname: readHostname(),
  };
};

export function isResponderE2EEEnabled() {
  return true;
  return resolveResponderE2EEFlagDiagnostics().enabled;
}
